import * as React from 'react';
import { useHistory } from 'react-router-dom';
import _routes from '../App/routes';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { showModal } from '../../redux/actions/activeModal.actions';
import { ModalName } from '../../types/ModalNames';
import { Breadcrumbs as WSRBreadcrumbs } from 'wix-style-react';

interface IBreadcrumbs extends InjectedTranslateProps {
    routePath: string;
    routes?: any;
    value?: string;
    disableChangePath?: boolean;
}

const Breadcrumbs: React.FC<IBreadcrumbs> = ({ t, routePath, routes, value, disableChangePath }) => {

  const dispatch = useDispatch();
  const history = useHistory();

  const currentRoutes = useMemo<any>(() => routes || _routes, [routes]);

  const entryItem = useMemo(() => currentRoutes.find(route => [route.matchPath, route.path].includes(routePath)), [currentRoutes, routePath]);

  const onBreadcrumbClick = useCallback(
    ({ id }) => {
      if (id !== entryItem.path) {
        if (!disableChangePath) {
          history.push(id);
        } else {
          dispatch(showModal(ModalName.DiscardChanges, { onOk: () => history.push(id) }));
        }
      }
    }
    , [history, disableChangePath]);

  const items = useMemo<any>(() =>
    buildBreadcrumbs(entryItem).map(({ path, title, id, dynamicValue }) => ({
          id: path,
          value: getBreadcrumbValue(dynamicValue, title, value, t),
      })
    ), [entryItem, value]);

    return (
        <WSRBreadcrumbs dataHook="team-management-breadcrumbs" items={items} activeId={entryItem.path} onClick={onBreadcrumbClick}/>
    );
};

export const buildBreadcrumbs = (item, breadcrumbs = []) => {
    breadcrumbs.unshift(item);
    if (!item.getParent) { return breadcrumbs; }
    return buildBreadcrumbs(item.getParent(), breadcrumbs);
};

const getBreadcrumbValue = (dynamicValue, title, value, t) => {
  if (dynamicValue) {
      return value;
  }
  return t(title);
};

export default translate()(Breadcrumbs);
